import NavTabs from '../NavTabs'

const DATA_EDIT_TABS = [
  { labelKey: 'nav.tabs.agroDataEdit', to: 'agro' },
  { labelKey: 'nav.tabs.pickingDataEdit', to: 'picking' },
  { labelKey: 'nav.tabs.packingDataEdit', to: 'packing' },
  { labelKey: 'nav.tabs.timingDataEdit', to: 'timing' }
]

const DataEditNav = () => <NavTabs tabs={DATA_EDIT_TABS} />

export default DataEditNav
